import {EggoCart} from "./eggo-cart";
import {
    EVENT_SHOW_MINI_CART,
    documentEventDispatcher,
    EVENT_ADD_TO_CART
} from "./eggo-cart-events";
import {registerToggleCheckout} from "./eggo-cart-limit";

let eggoCart = null;

const openMiniCartOnIcon = () => {
    const miniCartIcon = document.querySelector(".header__icon--cart");
    if (!miniCartIcon) return;
    miniCartIcon.addEventListener("click", (e) => {
        e.preventDefault();
        openCartProcedure();
    });
}

const openCartProcedure = () => {
    if (!eggoCart) {
        eggoCart = new EggoCart();
        eggoCart.getCart();
    } else {
        documentEventDispatcher(EVENT_SHOW_MINI_CART);
    }
}


export const addToCart = (addToCartData) => {
    const url = `${routes.cart_add_url}.js`;
    const body = {
        items: addToCartData,
    };
    if (!eggoCart) {
        eggoCart = new EggoCart();
        eggoCart.getCart(url, body);
    } else {
        documentEventDispatcher(EVENT_ADD_TO_CART, {
            url: url,
            data: body
        });
    }
}

export const removeItemCart = (productId) => {
    const url = `${routes.cart_change_url}.js`;
    const body = {
        id: productId,
        quantity: 0
    }

    if (!eggoCart) {
        eggoCart = new EggoCart();
        eggoCart.getCart(url, body);
    } else {
        documentEventDispatcher(EVENT_ADD_TO_CART, {
            url: url,
            data: body
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    openMiniCartOnIcon();
    registerToggleCheckout();
});
